/* ============================================================
   ANRML PREMIUM — theme.js v3.0
   Modular | Mínimo | Sin dependencias externas
   ============================================================ */

(function () {
  'use strict';

  /* ── UTILS ──────────────────────────────────────────────── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  // Debe coincidir con el `money_with_currency` de Liquid, que en esta tienda
  // renderiza "$ 999.00 MXN" (con espacio tras el símbolo). Sin ese espacio el
  // precio "saltaba" al cambiar de talla, porque el JS reescribe el mismo texto.
  function formatMoney(cents, symbol = '$') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    return symbol + ' ' + (parseInt(cents, 10) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' MXN';
  }

  function showToast(msg, duration = 3200) {
    let t = $('#toast') || (() => {
      const el = document.createElement('div');
      el.id = 'toast'; el.className = 'toast';
      document.body.appendChild(el); return el;
    })();
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(() => t.classList.remove('show'), duration);
  }

  /* ── NAV SCROLL BEHAVIOR ────────────────────────────────── */
  function initHeader() {
    const header = $('#site-header');
    const bar    = $('#announce-bar');
    if (!header) return;

    const isTransparent = header.dataset.style === 'transparent';
    let ticking = false;

    function update() {
      const scrolled = window.scrollY > 60;
      header.classList.toggle('is-scrolled', scrolled);
      header.classList.toggle('bar-hidden', window.scrollY > (bar?.offsetHeight || 36));
      if (!isTransparent) header.classList.add('is-solid');
      ticking = false;
    }

    on(window, 'scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });

    update();
  }

  /* ── MEGA MENU ──────────────────────────────────────────── */
  function initMegaMenu() {

    $$('.header__nav-item[data-mega]').forEach(item => {
      const menu = item.querySelector('.mega-menu');
      if (!menu) return;
      let timeout;
      const open  = () => { clearTimeout(timeout); menu.classList.add('is-open'); };
      const close = () => { timeout = setTimeout(() => menu.classList.remove('is-open'), 120); };
      on(item, 'mouseenter', open);
      on(item, 'mouseleave', close);
      on(menu, 'mouseenter', () => clearTimeout(timeout));
      on(menu, 'mouseleave', close);
    });
  }

  /* ── MOBILE MENU ────────────────────────────────────────── */
  function initMobileMenu() {
    const menu    = $('#mobile-menu');
    const overlay = $('#mobile-overlay');
    const openBtn = $('#hamburger');
    const closeBtn= $('#mobile-close');
    if (!menu) return;

    const open  = () => { menu.classList.add('is-open'); overlay?.classList.add('is-open'); openBtn?.classList.add('open'); document.body.style.overflow = 'hidden'; openBtn?.setAttribute('aria-expanded','true'); };
    const close = () => { menu.classList.remove('is-open'); overlay?.classList.remove('is-open'); openBtn?.classList.remove('open'); document.body.style.overflow = ''; openBtn?.setAttribute('aria-expanded','false'); };

    on(openBtn, 'click', open);
    on(closeBtn, 'click', close);
    on(overlay, 'click', close);
    on(document, 'keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ── SEARCH OVERLAY ─────────────────────────────────────── */
  function initSearch() {
    const overlay  = $('#search-overlay');
    const openBtn  = $('#search-open');
    const closeBtn = $('#search-close');
    const input    = overlay?.querySelector('.search-overlay__input');
    if (!overlay) return;

    const open  = () => { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; setTimeout(() => input?.focus(), 50); };
    const close = () => { overlay.classList.remove('is-open'); document.body.style.overflow = ''; };

    on(openBtn, 'click', open);
    on(closeBtn, 'click', close);
    on(document, 'keydown', e => { if (e.key === 'Escape') close(); });
    on(overlay, 'click', e => { if (e.target === overlay) close(); });
  }

  /* ── CART COUNT ─────────────────────────────────────────── */
  function updateCartCount(count) {

    $$('.cart-badge, #cart-count').forEach(el => {
      el.textContent = count;
      el.classList.toggle('show', count > 0);
      el.classList.toggle('visible', count > 0);
    });
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(c => updateCartCount(c.item_count))
      .catch(() => {});
  }

  /* ── ADD TO CART ────────────────────────────────────────── */
  window.addToCart = function (variantId, qty = 1, btn = null, openDrawer = true) {
    if (btn) { btn.classList.add('is-loading'); }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(r => { if (!r.ok) throw new Error('Error adding to cart'); return r.json(); })
    .then(() => fetch('/cart.js').then(r => r.json()))
    .then(cart => {
      updateCartCount(cart.item_count);
      if (openDrawer) openCartDrawer(cart);
      else showToast('✓ AÑADIDO AL CARRITO');
      return cart;
    })
    .catch(err => {
      console.error(err);
      showToast('⚠ ERROR — INTENTA DE NUEVO');
    })
    .finally(() => {
      if (btn) btn.classList.remove('is-loading');
    });
  };

  /* ── PRODUCT FORMS ──────────────────────────────────────── */
  function initProductForms() {

    $$('.product-form').forEach(form => {
      on(form, 'submit', e => {
        e.preventDefault();
        const id  = form.querySelector('[name="id"]')?.value;
        const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
        const btn = form.querySelector('.btn-atc');
        if (!id) return;
        window.addToCart(id, qty, btn);
      });
    });

    // Quick add from cards
    on(document, 'click', e => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      const id = btn.dataset.variantId || btn.dataset.quickAdd;
      if (id) window.addToCart(id, 1, btn);
    });
  }

  /* ── VARIANT SELECTOR ───────────────────────────────────── */
  function initVariantSelector() {
    if (!window.productData) return;
    const { variants, options } = window.productData;

    let selected = variants[0]
      ? [variants[0].option1, variants[0].option2, variants[0].option3].filter(Boolean)
      : [];

    function matchVariant(opts) {
      return variants.find(v =>
        v.option1 === opts[0] &&
        (options.length < 2 || v.option2 === opts[1]) &&
        (options.length < 3 || v.option3 === opts[2])
      );
    }

    function applyVariant(v) {
      if (!v) return;
      const idInput = document.getElementById('variant-id');
      if (idInput) idInput.value = v.id;

      // Price
      const priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = formatMoney(v.price);

      // Compare price
      const compareEl = document.getElementById('product-price-compare');
      if (compareEl) {
        if (v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // ATC button state
      const atcBtn = document.getElementById('atc-btn');
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.classList.toggle('btn--sold-out', !v.available);
        const txt = atcBtn.querySelector('.btn__text');
        if (txt) txt.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
      }

      // Image swap — solo si la variante tiene imagen propia válida
      // (las tallas comparten imagen; sin esto se ponía src="null" y desaparecía)
      if (v.featured_image && v.featured_image !== 'null') {
        const img = document.getElementById('gallery-main-img');
        if (img) { img.style.opacity = '0'; setTimeout(() => { img.src = v.featured_image; img.style.opacity = '1'; }, 150); }
      }

      // SKU
      const skuEl = document.getElementById('product-sku');
      if (skuEl) skuEl.textContent = v.sku || '—';
    }


    $$('.product-option').forEach(optEl => {
      const idx = parseInt(optEl.dataset.index, 10);

      $$('.size-btn', optEl).forEach(btn => {
        on(btn, 'click', function () {

          $$('.size-btn', optEl).forEach(b => b.classList.remove('is-active'));
          this.classList.add('is-active');
          selected[idx] = this.dataset.value;
          applyVariant(matchVariant(selected));
        });
      });
    });
  }

  /* ── GALLERY THUMBS ─────────────────────────────────────── */
  function initGallery() {
    const mainImg = document.getElementById('gallery-main-img');
    if (!mainImg) return;

    $$('.product-gallery__thumb').forEach(thumb => {
      on(thumb, 'click', function () {

        $$('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = this.dataset.src;
          mainImg.alt = this.dataset.alt || '';
          mainImg.style.opacity = '1';
        }, 150);
      });
    });
  }

  /* ── CART DRAWER ────────────────────────────────────────── */
  function openCartDrawer(cart) {
    const drawer  = $('#cart-drawer');
    const overlay = $('#cart-overlay');
    if (!drawer) { window.location.href = '/cart'; return; }

    renderCartDrawer(cart);
    drawer.classList.add('is-open');
    overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    const drawer  = $('#cart-drawer');
    const overlay = $('#cart-overlay');
    drawer?.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderCartDrawer(cart) {
    const itemsEl = $('#cart-drawer-items');
    const totalEl = $('#cart-drawer-total');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div class="cart-drawer__empty">
          <div class="cart-drawer__empty-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="23" stroke="currentColor" stroke-width="1"/>
              <path d="M14 18H34L31 32H17L14 18Z" stroke="currentColor" stroke-width="1.2" fill="none"/>
              <circle cx="20" cy="36" r="1.5" fill="currentColor"/>
              <circle cx="28" cy="36" r="1.5" fill="currentColor"/>
            </svg>
          </div>
          <p class="cart-drawer__empty-title">TU CARRITO ESTÁ VACÍO</p>
          <p class="cart-drawer__empty-text">Aún no has añadido ninguna pieza.</p>
        </div>`;
      if (totalEl) totalEl.textContent = formatMoney(0);
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-drawer__item" data-key="${item.key}">
        <a href="${item.url}" class="cart-drawer__img">
          <img src="${item.image}" alt="${item.title}" loading="lazy">
        </a>
        <div class="cart-drawer__item-body">
          <span class="cart-drawer__item-name">${item.product_title.toUpperCase()}</span>
          <span class="cart-drawer__item-variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</span>
          <div class="cart-drawer__item-foot">
            <div class="qty-wrap">
              <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Reducir">−</button>
              <input class="qty-input" type="number" value="${item.quantity}" min="0" data-key="${item.key}" aria-label="Cantidad">
              <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Aumentar">+</button>
            </div>
            <span class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</span>
          </div>
          <button class="cart-drawer__remove" data-key="${item.key}">ELIMINAR</button>
        </div>
      </div>`).join('');

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  function initCartDrawer() {
    const drawer  = $('#cart-drawer');
    const overlay = $('#cart-overlay');
    if (!drawer) return;

    // Close
    on($('#cart-drawer-close'), 'click', closeCartDrawer);
    on(overlay, 'click', closeCartDrawer);
    on(document, 'keydown', e => { if (e.key === 'Escape') closeCartDrawer(); });

    // Open cart icon
    on($('#header-cart-btn'), 'click', e => {
      e.preventDefault();
      fetch('/cart.js').then(r => r.json()).then(c => openCartDrawer(c));
    });

    // Qty + remove (delegated)
    on(drawer, 'click', e => {
      const qtyBtn = e.target.closest('.qty-btn');
      const remBtn = e.target.closest('.cart-drawer__remove');
      if (qtyBtn) {
        const key = qtyBtn.dataset.key;
        const qty = parseInt(qtyBtn.dataset.qty, 10);
        updateCartItem(key, qty >= 0 ? qty : 0);
      }
      if (remBtn) updateCartItem(remBtn.dataset.key, 0);
    });

    on(drawer, 'change', e => {
      const input = e.target.closest('.qty-input');
      if (input) updateCartItem(input.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
    });

    // Checkout
    on($('#cart-drawer-checkout'), 'click', () => { window.location.href = '/checkout'; });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
      if (cart.item_count === 0) setTimeout(() => location.reload(), 350);
    })
    .catch(() => showToast('⚠ ERROR AL ACTUALIZAR'));
  }

  /* ── FILTER TABS ────────────────────────────────────────── */
  function initFilterTabs() {

    $$('.filter-chip').forEach(chip => {
      on(chip, 'click', function () {
        const container = this.closest('section') || document;

        $$('.filter-chip', container).forEach(c => c.classList.remove('is-active'));
        this.classList.add('is-active');
        const filter = this.dataset.filter;

        $$('.prod-card, .product-card', container).forEach(card => {
          const match = filter === 'all' || card.dataset.collection === filter || card.dataset.tags?.includes(filter);
          card.style.display = match ? '' : 'none';
        });
      });
    });
  }

  /* ── SIZE BUTTONS ───────────────────────────────────────── */
  function initSizeButtons() {

    $$('.product-option').forEach(group => {

      $$('.size-btn', group).forEach(btn => {
        on(btn, 'click', function () {

          $$('.size-btn', group).forEach(b => b.classList.remove('is-active'));
          this.classList.add('is-active');
        });
      });
    });
  }

  /* ── QTY CONTROLS ───────────────────────────────────────── */
  function initQtyControls() {
    on(document, 'click', e => {
      const minus = e.target.closest('.qty-minus');
      const plus  = e.target.closest('.qty-plus');
      if (minus || plus) {
        const wrap = (minus || plus).closest('.qty-wrap') || (minus || plus).parentElement;
        const inp  = wrap?.querySelector('.qty-input');
        if (!inp) return;
        const val = parseInt(inp.value, 10) || 1;
        inp.value = minus ? Math.max(1, val - 1) : val + 1;
        inp.dispatchEvent(new Event('change'));
      }
    });
  }

  /* ── LAZY LOAD (IntersectionObserver fallback) ──────────── */
  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) return; // native lazy load
    const imgs = $$('img[loading="lazy"]');
    if (!imgs.length) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) img.src = img.dataset.src;
          io.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    imgs.forEach(img => io.observe(img));
  }

  /* ── NEWSLETTER FORM ────────────────────────────────────── */
  function initNewsletter() {
    on($('#newsletter-form'), 'submit', function (e) {
      // Let Shopify handle it — just show feedback
      const email = this.querySelector('input[type="email"]')?.value;
      if (email) setTimeout(() => showToast('✓ ¡BIENVENIDO A LA LISTA PRIVADA!'), 500);
    });
  }

  /* ── BUY NOW ────────────────────────────────────────────── */
  function initBuyNow() {
    on($('#buy-now-btn'), 'click', () => {
      const id  = document.getElementById('variant-id')?.value;
      const qty = parseInt(document.getElementById('qty-input')?.value || '1', 10);
      if (!id) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: qty })
      }).then(() => { window.location.href = '/checkout'; });
    });
  }

  /* ── PAGE TRANSITION — mosaic tiles ────────────────────── */
  function initPageTransition() {
    const overlay = document.getElementById('pt-overlay');
    if (!overlay) return;

    // Build tiles based on CSS grid vars
    const style = getComputedStyle(document.documentElement);
    const cols = parseInt(style.getPropertyValue('--pt-cols')) || 4;
    const rows = parseInt(style.getPropertyValue('--pt-rows')) || 4;
    const frag = document.createDocumentFragment();
    for (let i = 0; i < cols * rows; i++) {
      const tile = document.createElement('div');
      tile.className = 'pt-tile';
      frag.appendChild(tile);
    }
    overlay.appendChild(frag);

    // Page just loaded — remove animating class to reveal content
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.documentElement.classList.remove('pt-animating');
      });
    });

    // Botón "atrás": la página se restaura desde el bfcache tal como quedó, es
    // decir CON `pt-animating` (se añade al salir). Ni el script del <head> ni
    // DOMContentLoaded se vuelven a ejecutar, así que nadie la quitaría y la
    // pantalla queda tapada por el overlay (overflow:hidden + pointer-events:all).
    window.addEventListener('pageshow', e => {
      if (e.persisted) {
        document.documentElement.classList.remove('pt-animating', 'pt-exit');
      }
    });

    // Intercept internal navigation
    document.addEventListener('click', e => {
      const link = e.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript') ||
          href.startsWith('mailto') || href.startsWith('tel') ||
          link.target === '_blank') return;
      try {
        const dest = new URL(href, window.location.origin);
        if (dest.origin !== window.location.origin) return;
      } catch { return; }

      e.preventDefault();
      document.documentElement.classList.add('pt-animating');
      setTimeout(() => { window.location.href = href; }, 420);
    }, true);
  }

  /* ── INIT ───────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initPageTransition();
    initHeader();
    initMegaMenu();
    initMobileMenu();
    initSearch();
    initProductForms();
    initVariantSelector();
    initGallery();
    initCartDrawer();
    initFilterTabs();
    initSizeButtons();
    initQtyControls();
    initLazyLoad();
    initNewsletter();
    initBuyNow();
    fetchCartCount();
  });

})();
